"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMining = void 0;
const mining_1 = require("../../../models/state/mining");
const initMining_1 = require("../../../models/instructions/initMining");
const account_1 = require("../../../utils/account");
const initMining = (connection, signers, instructions, cleanupInstructions, lendingMarket, wallet, lendingProgramID) => __awaiter(void 0, void 0, void 0, function* () {
    const accountRentExempt = yield connection.getMinimumBalanceForRentExemption(mining_1.MiningLayout.span);
    const miningAccount = (0, account_1.createUninitializedMiningAccount)(instructions, lendingProgramID, wallet, accountRentExempt, signers);
    instructions.push((0, initMining_1.createInitMiningInstruction)(miningAccount, wallet, lendingMarket, lendingProgramID));
    return miningAccount;
});
exports.initMining = initMining;
